export default {
  patients: {
    label: 'Пациенты',
    viewPatients: 'Просмотр пациентов',
    noPatients: 'Пациентов еще нет, давайте добавим первого!',
    viewPatient: 'Просмотр пациента',
    editPatient: 'Редактировать пациента',
    newPatient: 'Новый пациент',
    patientsList: 'Список пациентов',
    successfullyCreated: 'Пациент успешно добавлен',
    successfullyAddedNote: 'Новая заметка успешно добавлена',
    successfullyAddedRelatedPerson: 'Успешно добавлен новый родственник',
  },
}
